
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11877',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11877",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.310",
  "data-fetching-client": "static-1.9566",
  "foundations-components": "static-1.7701",
  "foundations-components-legacy": "static-1.726",
  "foundations-theming": "static-1.4302",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.80",
  "head-dlb": "static-1.4921",
  "hs-test-utils": "static-1.7902",
  "hub-http-shared-msw-handlers": "static-1.9707",
  "hubspot-dlb": "static-2.1828",
  "hubspot-url-utils": "static-1.4034",
  "HubStyleTokens": "static-2.11340",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6360",
  "marketplace-storefront-base": "static-1.11938",
  "quartz": "static-1.6853",
  "react-dlb": "static-1.76",
  "react-rhumb": "static-1.16544",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2753",
  "reporting-testing-lib": "static-1.8897",
  "settings-ui-lib": "static-1.12416",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6931",
  "ui-addon-i18n": "static-1.11038",
  "ui-addon-react-router-dom": "static-1.9435",
  "unified-auth": "static-1.335",
  "unified-auth-core-lib": "static-1.616",
  "usage-tracker": "static-1.7227",
  "usage-tracker-core": "static-1.7077",
  "customer-data-property-utils": "static-1.7973",
  "history": "static-4.47",
  "hub-http": "static-1.6109",
  "integrations-lib": "static-1.15737",
  "marketplace-ui-common": "static-1.19254",
  "property-management-iframe": "static-1.12762",
  "quartz-config": "static-1.631",
  "quartz-core": "static-1.6072",
  "quartz-routing": "static-1.283",
  "quick-fetch": "static-1.3825",
  "react": "static-7.184",
  "rpc-client-utils": "static-1.4534",
  "ts-schema": "static-1.3988",
  "ui-universal-auth": "static-1.8821",
  "UIComponents": "static-3.8287",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.425",
  "hs-promise-rejection-tracking": "static-1.5473",
  "PortalIdParser": "static-2.386",
  "raven": "static-3.5808",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.76",
  "metrics-js": "static-1.9522",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3316",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3130",
  "quartz-webpack": "static-1.3077",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3970",
  "floating-ui": "static-1.54",
  "foundations-assets": "static-1.4736",
  "foundations-theming-specialty": "static-1.2018",
  "framer-motion": "static-1.70",
  "hs-story-utils": "static-1.9319",
  "react-aria": "static-1.64",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5258",
  "react-virtualized": "static-2.97",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1493",
  "ui-fonts": "static-1.602",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-theming": "static-1.2785",
  "foundations-theming-base": "static-1.3287",
  "stylex": "static-1.30",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.3013",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4215",
  "ai-components-ui-library": "static-1.8642",
  "ai-rendering-library": "static-1.9655",
  "chirp-fetch": "static-1.1772",
  "connections-embed-lib": "static-1.780",
  "copilot-toolkit": "static-1.10808",
  "laboratory-lib": "static-3.7050",
  "marketplace-embed": "static-1.21746",
  "marketplace-ui-details": "static-1.9150",
  "marketplace-ui-reviews": "static-1.19210",
  "marketplace-ui-tracking": "static-1.13425",
  "sanitize-text": "static-1.8035",
  "ui-addon-video-player": "static-1.8587",
  "usage-tracker-multi": "static-1.5641",
  "usage-tracker-session-replay": "static-1.4913",
  "wootric-nps": "static-1.6874",
  "apollo-link-hub-http": "static-2.4541",
  "immer": "static-1.33",
  "immerable": "static-1.4043",
  "highcharts": "static-8.102",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2427",
  "reporting-data": "static-1.66964",
  "cssUtils": "static-1.764",
  "flux-actions": "static-1.323",
  "HubStyle": "static-2.11648",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10100",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10264",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7217",
  "icons": "static-2.637",
  "marketplace-ui-apps-core": "static-1.17787",
  "storybook-react": "static-1.31",
  "trellis-story-utils": "static-1.4410",
  "foundations-components-test-utils": "static-1.5184",
  "quartz-i18n": "static-1.528",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3624",
  "customer-data-objects": "static-1.7545",
  "property-translator": "static-1.5299",
  "frontend-preferences-client": "static-1.7815",
  "hs-promise-utils": "static-1.5485",
  "hubspot-apollo-client": "static-1.4769",
  "integrations-error-boundary-lib": "static-1.13152",
  "integrations-tracking-lib": "static-1.5486",
  "native-integrations-shared-strings": "static-1.7677",
  "reselect": "static-2.16",
  "sanitize": "static-1.4363",
  "superstore": "static-1.4659",
  "ui-shepherd-react": "static-3.10038",
  "ai-settings-ui-library": "static-1.7705",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4561",
  "immutable-less": "static-1.4544",
  "marketplace-ui-client-types": "static-1.16661",
  "nav-meta": "static-1.29249",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10136",
  "ui-addon-upgrades": "static-9.17820",
  "inbound-db-properties-service-client": "static-1.3756",
  "property-management-common": "static-1.5050",
  "ui-addon-iframeable": "static-1.8940",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.528",
  "quartz-head": "static-1.518",
  "quartz-test": "static-1.528",
  "quartz-tracking": "static-1.232",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3056",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20767",
  "ContentUtils": "static-1.67982",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2384",
  "customer-data-filters-ui": "static-1.39284",
  "customer-data-objects-ui-components": "static-1.12908",
  "customer-data-reference-ui-components": "static-1.13043",
  "embedded-academy-lib": "static-1.13917",
  "ExportDialog": "static-6.10281",
  "highlight.js": "static-1.77",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40938",
  "reporting-snowflake": "static-1.55582",
  "reporting-ui-components": "static-2.64235",
  "reporting-visualizations": "static-1.59040",
  "ui-addon-teams": "static-1.21393",
  "magpie-lib": "static-1.5484",
  "magpie-types": "static-1.4944",
  "simple-logging-lib": "static-1.2942",
  "navigation-components": "static-1.17612",
  "ai-studio-lib": "static-1.11272",
  "app-governance-lib": "static-1.1188",
  "developer-experience-shared-components": "static-1.10397",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7881",
  "ui-product-approvals": "static-1.27805",
  "ui-tool-access": "static-1.10037",
  "usage-based-billing-components-lib": "static-1.8289",
  "usage-tracker-anonymous": "static-1.5644",
  "usage-tracker-public": "static-1.7038",
  "amplitude-session-replay-browser": "static-1.58",
  "inbound-db-meta-service-client": "static-1.3499",
  "persist-promise": "static-1.3599",
  "reference-resolvers": "static-1.8057",
  "ui-extensibility-client-types": "static-1.3830",
  "hubspot-apollo-cache": "static-1.228",
  "universal-page-editor-lib": "static-1.2897",
  "final-form": "static-1.68",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2452",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4961",
  "purchase-motions-components": "static-1.5661",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1442",
  "crm-component-utils": "static-1.38748",
  "crm-properties-common-lib": "static-1.5765",
  "customer-data-properties": "static-1.51134",
  "framework-data-schema-resolvers": "static-1.6766",
  "property-value-citations": "static-1.1748",
  "reference-resolvers-lite": "static-1.7980",
  "navigation-messaging": "static-1.6939",
  "hubspotter-http-shared-msw-handlers": "static-1.9705",
  "cms-field-types": "static-1.4700",
  "content-icons-ui": "static-1.2196",
  "conversations-skeleton-state": "static-1.7140",
  "crm-message-bus": "static-1.42655",
  "customer-data-filters-ui-msw-helpers": "static-1.21719",
  "customer-data-ui-utilities": "static-1.9715",
  "FormUrlGenerator": "static-2.4610",
  "framework-builder-read-service-client": "static-1.3918",
  "framework-data-schema-quick-fetch": "static-1.6671",
  "multi-account-reference-resolvers": "static-1.873",
  "onboarding-tours": "static-1.16399",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13345",
  "academy-common-lib": "static-1.13377",
  "content-assistance-lib": "static-1.7587",
  "dashboard-lib": "static-1.81038",
  "file-manager-components": "static-1.23253",
  "getting-started-shared-tasks": "static-1.18166",
  "hubspot-prosemirror": "static-1.17901",
  "hubspot-prosemirror-plugins": "static-1.17893",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19640",
  "share-with-third-party-component-lib": "static-1.8585",
  "ui-addon-draggable": "static-3.4660",
  "ui-asset-management-lib": "static-1.10861",
  "ui-business-units-lib": "static-1.8930",
  "user-context": "static-1.4990",
  "growth-payments-core": "static-1.25016",
  "reporting-plugins": "static-1.10122",
  "reporting-reports": "static-1.66642",
  "idb-keyval": "static-1.42",
  "reactive-lib": "static-1.615",
  "nest": "static-1.112",
  "codemirror": "static-5.93",
  "feedback-loader": "static-1.29082",
  "react-codemirror": "static-1.10514",
  "framework-listing-lib": "static-2.28326",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30398",
  "apps-service-types": "static-1.3768",
  "oauth-service-types": "static-1.4138",
  "onboarding-scopes": "static-1.6353",
  "onboarding-tours-client": "static-1.4613",
  "platform-infra-nav-components": "static-1.7576",
  "subscription-experience-data-types": "static-1.14712",
  "crm-record-cards-service-types": "static-1.3519",
  "location-customization-utils-lib": "static-1.8872",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4391",
  "nav-client-types": "static-1.2249",
  "purchase-motions-api": "static-1.5664",
  "signup-constants": "static-1.18635",
  "signup-ui-url-generator": "static-2.7930",
  "trials-service-types": "static-1.3792",
  "card-properties-lib": "static-1.43817",
  "commerce-subscription-lib": "static-1.36756",
  "crm-actions": "static-1.6205",
  "crm-cards-sdk": "static-1.43224",
  "customer-data-properties-shared-msw-handlers": "static-1.9034",
  "customer-data-tracking": "static-1.6773",
  "hs-resources": "static-1.26",
  "pulse": "static-1.425",
  "calling-global-api": "static-1.64060",
  "calling-internal-common": "static-1.31192",
  "calling-lifecycle-internal": "static-1.65442",
  "calling-lifecycle-messages": "static-1.57736",
  "commerce-products-lib": "static-1.9117",
  "conditional-properties-service-client": "static-1.3707",
  "crm-links": "static-1.6166",
  "external-options-client-types": "static-1.4068",
  "google-libphonenumber": "static-1.36",
  "inbounddb-objects-service-types": "static-1.4133",
  "meetings-icalendar-utils-lib": "static-1.521",
  "multi-currency-client-types": "static-1.3599",
  "object-builder-ui-client": "static-1.48349",
  "pipeline-validation-client-types": "static-1.3875",
  "smart-property-lib": "static-1.6383",
  "tiered-pricing": "static-1.994",
  "ui-addon-form-validation": "static-1.10882",
  "crm-pipelines-api-client-types": "static-1.4052",
  "react-dnd-compat": "static-1.4509",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5259",
  "growth-onboarding-confetti": "static-1.2962",
  "growth-onboarding-next-action-utils": "static-1.1573",
  "onboarding-tours-utils": "static-1.465",
  "ui-shepherd-tracker": "static-1.7419",
  "academy-service-client": "static-1.3571",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28212",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8273",
  "video-components-external": "static-1.10898",
  "video-data-lib": "static-1.34556",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8438",
  "payment-link-components": "static-1.23204",
  "ui-addon-emoji-picker": "static-1.9778",
  "EmailSignatureEditor": "static-1.24120",
  "viral-links-lib": "static-1.6929",
  "data-token-picker": "static-1.16211",
  "FileManagerLib": "static-1.38893",
  "react-flip-move": "static-1.68",
  "timezone-utils": "static-2.5134",
  "getting-started-shared-tasks-store": "static-1.17284",
  "campaign-roi-lib": "static-1.8591",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7214",
  "customer-data-views-management": "static-1.25194",
  "framework-data-table": "static-2.11643",
  "marketing-platform-lib": "static-1.6740",
  "nudge-client-utils": "static-1.2338",
  "nudge-custom-ui-functions": "static-1.835",
  "app-users-service-client": "static-1.5447",
  "app-users-service-types": "static-1.4855",
  "mini-checkout-client": "static-1.26538",
  "onboarding-utils": "static-1.5241",
  "permissions-shared-i18n-strings-fe": "static-1.1999",
  "ui-coaching-tips-shared-config": "static-1.28197",
  "edison-service-client-types": "static-1.278",
  "eligibility-engine-service-types": "static-1.3073",
  "crm_data": "static-4.91581",
  "customer-data-sidebar": "static-2.45685",
  "enrichment-properties-lib": "static-1.15501",
  "commerce-billing-lib": "static-1.18759",
  "commerce-shared-components-lib": "static-1.18224",
  "commerce-tools-ui-lib": "static-1.10071",
  "crm-fe-perf": "static-1.22793",
  "directed-graph": "static-1.828",
  "event-emitter": "static-1.838",
  "fast-json-patch": "static-1.61",
  "calling-error-reporting": "static-1.31198",
  "shared-worker-versioning": "static-1.10929",
  "calling-usage-tracker": "static-1.6432",
  "voice-sms-access-library": "static-1.552",
  "commerce-permissions": "static-1.656",
  "products-iframe-lib": "static-1.7606",
  "products-ui-components-shared-msw-handlers": "static-1.10089",
  "data-agent-kit": "static-1.17",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9790",
  "policy-lib": "static-1.6673",
  "react-tinymce": "static-1.54906",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9853",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54032",
  "tinymce-plugins": "static-1.57146",
  "tinymce-themes": "static-1.56002",
  "onboarding-data-sync-lib": "static-1.1775",
  "growth-onboarding-next-action-components": "static-1.1601",
  "user-context-client": "static-1.4502",
  "growth-onboarding-feedback-components": "static-1.6472",
  "content-media-composition-data-lib": "static-1.11854",
  "content-media-compositions": "static-2.15861",
  "media-bridge-lib": "static-1.18731",
  "commerce-tours-lib": "static-1.5890",
  "growth-onboarding-reliability": "static-1.4977",
  "sales-checkout-service-client": "static-1.3559",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21479",
  "sales-email-signature-service-client": "static-1.3734",
  "audio-components": "static-1.5750",
  "FileManagerCore": "static-1.38752",
  "FileManagerImages": "static-1.36404",
  "video-components": "static-1.12901",
  "crm-export-dialog": "static-1.6186",
  "crm-index-associations-lib": "static-1.6326",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1597",
  "tanstack-virtual": "static-1.28",
  "nudge-custom-function-registry": "static-1.2095",
  "nudge-renderer-utils": "static-1.2414",
  "whisper-core-api": "static-1.6261",
  "InboxConnectUtils": "static-4.14490",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5269",
  "settings-content-modals": "static-1.45743",
  "crm_universal": "static-1.21813",
  "customer-data-email": "static-1.17841",
  "card-payment-highlight-lib": "static-1.36807",
  "card-subscription-highlight-lib": "static-1.39179",
  "commerce-contract-lib": "static-1.11550",
  "invoices-highlight-card-lib": "static-1.54332",
  "orders-highlight-card-lib": "static-1.21132",
  "products-highlight-card-lib": "static-1.17401",
  "quotes-highlight-card-lib": "static-1.71545",
  "breeze-intelligence-kit": "static-1.5461",
  "crm-source-interpretation-lib": "static-1.5225",
  "utility-belt": "static-1.2430",
  "payments-enrollment-embed-lib": "static-1.22294",
  "stripe-embedded-components": "static-1.7310",
  "customer-data-rte": "static-1.32697",
  "cv-backend-services": "static-1.1536",
  "growth-onboarding-empty-states": "static-1.5512",
  "payments-post-enroll-local-storage-lib": "static-1.5002",
  "qrcode-generator": "static-1.67",
  "quotes-client-types": "static-1.37635",
  "calling-orchestration-schema": "static-1.35329",
  "sales-views-client-types": "static-1.4154",
  "hub-http-contrib": "static-1.2933",
  "interframe": "static-3.4654",
  "tinymce-data": "static-1.40117",
  "ui-addon-sales-email": "static-1.5102",
  "layout-dnd-components": "static-1.12230",
  "layout-dnd-utils": "static-1.11205",
  "ui-brand-identity-lib": "static-1.14704",
  "NamespacedHubStyle": "static-2.8978",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4422",
  "video-embed": "static-1.35390",
  "social-insights-client-types": "static-1.21728",
  "deal-intel-utils": "static-1.1601",
  "checkout-sdk": "static-3.23381",
  "checkout-service-types": "static-1.3736",
  "company-details-components": "static-1.6076",
  "payment-method-components": "static-1.6787",
  "pricing-pages-ui-components": "static-1.13206",
  "quote-checkout-service-types": "static-1.3366",
  "upgrade-catalog-service-types": "static-1.3417",
  "access-control-lib": "static-1.10329",
  "EmailComponents": "static-1.54429",
  "EmailData": "static-1.53106",
  "redux-less": "static-2.9375",
  "sequences-lib": "static-1.7851",
  "ui-gdpr-components": "static-1.10239",
  "products-ui-components": "static-1.39636",
  "quotes-ui-lib": "static-1.80266",
  "accounting-integrations-ui-components": "static-1.6884",
  "invoices-ui-lib": "static-1.54348",
  "commerce-products-api": "static-1.2120",
  "invoices-iframe-lib": "static-1.56406",
  "quotes-modal-lib": "static-1.102223",
  "stripe-connect-js": "static-1.66",
  "draft-content-plugins": "static-1.27965",
  "ContentData": "static-1.68057",
  "layout-data-lib": "static-1.9530",
  "outpost": "static-1.4085",
  "hub-http-rxjs": "static-1.782",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3820",
  "billing-payments-client-types": "static-1.3880",
  "account-and-billing-fintech-outages": "static-3.18366",
  "pricing-pages-api": "static-1.13071",
  "ContentComponents": "static-2.70938",
  "marketing-contacts-lib": "static-1.9466",
  "marketing-email-service-types": "static-1.1834",
  "messaging-editing-lib": "static-1.45905",
  "messaging-usage-based-billing-components-lib": "static-1.767",
  "automation-ui-source-apps": "static-1.18527",
  "automation-ui-types": "static-1.19445",
  "messaging-types-lib": "static-1.45642",
  "onboarding-settings-client": "static-1.4394",
  "sequences-client-types-lib": "static-1.7708",
  "commerce-tax-lib": "static-1.410",
  "property-description-translator": "static-1.3744",
  "SalesContentIndexUI": "static-3.9067",
  "commerce-analytics-service-client": "static-1.3547",
  "totals-ui-components": "static-1.23251",
  "advanced-menus-core": "static-1.14956",
  "advanced-menus-lib": "static-1.11920",
  "ui-memberships-settings-lib": "static-1.33721",
  "demographics-service-types": "static-1.1541",
  "automation-ui-ubb": "static-1.5361",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7230",
  "data-token-views": "static-1.16192",
  "forms-utils-lib": "static-1.12369",
  "payments-embed-points-lib": "static-1.12809",
  "simple-menus-core": "static-1.14955",
  "simple-menus-lib": "static-1.16472",
  "ui-addon-draggable-compat": "static-2.4144",
  "videoconference-integration-components": "static-1.6662",
  "automation-applications-service-types": "static-1.3410",
  "automation-platform-service-types": "static-1.2548",
  "ContentEditorUI": "static-2.76793",
  "short-messages-app-service-client": "static-1.3877",
  "web-interactives-components": "static-1.13571",
  "web-interactives-data": "static-1.13572",
  "messaging-shared-utils-lib": "static-1.216",
  "messaging-user-info-utils-lib": "static-1.386",
  "email-portal-health-service-types": "static-1.867",
  "FireAlarmUi": "static-1.4419",
  "sales-templates-service-types-lib": "static-1.4076",
  "commerce-totals-service-types": "static-1.3726",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21381",
  "automation-ui-usage-tracking": "static-1.20844",
  "data-studio-ubb": "static-1.2389",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26691",
  "collaboration-sidebar": "static-1.57426",
  "content-management-data-lib": "static-1.5246",
  "copilot-plugins": "static-1.10781",
  "cta-picker": "static-1.36098",
  "customer-agent-discovery-components-lib": "static-1.2727",
  "editor-components": "static-1.13071",
  "editor-iframe-lib": "static-1.8250",
  "error-messaging-js": "static-1.5081",
  "FormsCommonComponents": "static-1.85538",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.63",
  "redux-request-state": "static-1.10536",
  "SharedLegalStrings": "static-1.1643",
  "smart-content-core": "static-1.42125",
  "smart-content-lib": "static-1.42778",
  "social-composer-lib": "static-1.58515",
  "structured-content-lib": "static-1.24881",
  "theme-previewer-lib": "static-1.52935",
  "tinymce-copilot": "static-1.16100",
  "xray-recommendation-lib": "static-1.7742",
  "automation-ui-routing": "static-1.20802",
  "sql-reporting-client-types": "static-1.5551",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41900",
  "campaigns-utils-lib": "static-1.3049",
  "reporting-enablement": "static-1.22449",
  "chatspot-widget-iframe": "static-1.20759",
  "collaboration-sidebar-common": "static-1.2223",
  "forms-ai-lib": "static-1.4146",
  "codemirror-dlb": "static-1.58352",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6319",
  "report-customization-components": "static-1.12800",
  "data-quality-ui-library": "static-1.12568",
  "html-to-image": "static-1.52",
  "reporting-insights-lib": "static-1.1368"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11877",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.310",
  "data-fetching-client": "/data-fetching-client/static-1.9566",
  "foundations-components": "/foundations-components/static-1.7701",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.726",
  "foundations-theming": "/foundations-theming/static-1.4302",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.80",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-test-utils": "/hs-test-utils/static-1.7902",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9707",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyleTokens": "/HubStyleTokens/static-2.11340",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6360",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11938",
  "quartz": "/quartz/static-1.6853",
  "react-dlb": "/react-dlb/static-1.76",
  "react-rhumb": "/react-rhumb/static-1.16544",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2753",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8897",
  "settings-ui-lib": "/settings-ui-lib/static-1.12416",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6931",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11038",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9435",
  "unified-auth": "/unified-auth/static-1.335",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.616",
  "usage-tracker": "/usage-tracker/static-1.7227",
  "usage-tracker-core": "/usage-tracker-core/static-1.7077",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7973",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6109",
  "integrations-lib": "/integrations-lib/static-1.15737",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19254",
  "property-management-iframe": "/property-management-iframe/static-1.12762",
  "quartz-config": "/quartz-config/static-1.631",
  "quartz-core": "/quartz-core/static-1.6072",
  "quartz-routing": "/quartz-routing/static-1.283",
  "quick-fetch": "/quick-fetch/static-1.3825",
  "react": "/react/static-7.184",
  "rpc-client-utils": "/rpc-client-utils/static-1.4534",
  "ts-schema": "/ts-schema/static-1.3988",
  "ui-universal-auth": "/ui-universal-auth/static-1.8821",
  "UIComponents": "/UIComponents/static-3.8287",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.425",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "raven": "/raven/static-3.5808",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.76",
  "metrics-js": "/metrics-js/static-1.9522",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3316",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3130",
  "quartz-webpack": "/quartz-webpack/static-1.3077",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3970",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4736",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2018",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9319",
  "react-aria": "/react-aria/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5258",
  "react-virtualized": "/react-virtualized/static-2.97",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1493",
  "ui-fonts": "/ui-fonts/static-1.602",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2785",
  "foundations-theming-base": "/foundations-theming-base/static-1.3287",
  "stylex": "/stylex/static-1.30",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3013",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4215",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8642",
  "ai-rendering-library": "/ai-rendering-library/static-1.9655",
  "chirp-fetch": "/chirp-fetch/static-1.1772",
  "connections-embed-lib": "/connections-embed-lib/static-1.780",
  "copilot-toolkit": "/copilot-toolkit/static-1.10808",
  "laboratory-lib": "/laboratory-lib/static-3.7050",
  "marketplace-embed": "/marketplace-embed/static-1.21746",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9150",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19210",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13425",
  "sanitize-text": "/sanitize-text/static-1.8035",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8587",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5641",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4913",
  "wootric-nps": "/wootric-nps/static-1.6874",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4541",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4043",
  "highcharts": "/highcharts/static-8.102",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "reporting-data": "/reporting-data/static-1.66964",
  "cssUtils": "/cssUtils/static-1.764",
  "flux-actions": "/flux-actions/static-1.323",
  "HubStyle": "/HubStyle/static-2.11648",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10100",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10264",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7217",
  "icons": "/icons/static-2.637",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17787",
  "storybook-react": "/storybook-react/static-1.31",
  "trellis-story-utils": "/trellis-story-utils/static-1.4410",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5184",
  "quartz-i18n": "/quartz-i18n/static-1.528",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3624",
  "customer-data-objects": "/customer-data-objects/static-1.7545",
  "property-translator": "/property-translator/static-1.5299",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7815",
  "hs-promise-utils": "/hs-promise-utils/static-1.5485",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4769",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13152",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5486",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7677",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4363",
  "superstore": "/superstore/static-1.4659",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10038",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7705",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4561",
  "immutable-less": "/immutable-less/static-1.4544",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16661",
  "nav-meta": "/nav-meta/static-1.29249",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10136",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17820",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3756",
  "property-management-common": "/property-management-common/static-1.5050",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8940",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.528",
  "quartz-head": "/quartz-head/static-1.518",
  "quartz-test": "/quartz-test/static-1.528",
  "quartz-tracking": "/quartz-tracking/static-1.232",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3056",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20767",
  "ContentUtils": "/ContentUtils/static-1.67982",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2384",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39284",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12908",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13043",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13917",
  "ExportDialog": "/ExportDialog/static-6.10281",
  "highlight.js": "/highlight.js/static-1.77",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40938",
  "reporting-snowflake": "/reporting-snowflake/static-1.55582",
  "reporting-ui-components": "/reporting-ui-components/static-2.64235",
  "reporting-visualizations": "/reporting-visualizations/static-1.59040",
  "ui-addon-teams": "/ui-addon-teams/static-1.21393",
  "magpie-lib": "/magpie-lib/static-1.5484",
  "magpie-types": "/magpie-types/static-1.4944",
  "simple-logging-lib": "/simple-logging-lib/static-1.2942",
  "navigation-components": "/navigation-components/static-1.17612",
  "ai-studio-lib": "/ai-studio-lib/static-1.11272",
  "app-governance-lib": "/app-governance-lib/static-1.1188",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10397",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7881",
  "ui-product-approvals": "/ui-product-approvals/static-1.27805",
  "ui-tool-access": "/ui-tool-access/static-1.10037",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8289",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5644",
  "usage-tracker-public": "/usage-tracker-public/static-1.7038",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3499",
  "persist-promise": "/persist-promise/static-1.3599",
  "reference-resolvers": "/reference-resolvers/static-1.8057",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3830",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.228",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2897",
  "final-form": "/final-form/static-1.68",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2452",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4961",
  "purchase-motions-components": "/purchase-motions-components/static-1.5661",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1442",
  "crm-component-utils": "/crm-component-utils/static-1.38748",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5765",
  "customer-data-properties": "/customer-data-properties/static-1.51134",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6766",
  "property-value-citations": "/property-value-citations/static-1.1748",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7980",
  "navigation-messaging": "/navigation-messaging/static-1.6939",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9705",
  "cms-field-types": "/cms-field-types/static-1.4700",
  "content-icons-ui": "/content-icons-ui/static-1.2196",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7140",
  "crm-message-bus": "/crm-message-bus/static-1.42655",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21719",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9715",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4610",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3918",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6671",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.873",
  "onboarding-tours": "/onboarding-tours/static-1.16399",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13345",
  "academy-common-lib": "/academy-common-lib/static-1.13377",
  "content-assistance-lib": "/content-assistance-lib/static-1.7587",
  "dashboard-lib": "/dashboard-lib/static-1.81038",
  "file-manager-components": "/file-manager-components/static-1.23253",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18166",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17901",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17893",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19640",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8585",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4660",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10861",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8930",
  "user-context": "/user-context/static-1.4990",
  "growth-payments-core": "/growth-payments-core/static-1.25016",
  "reporting-plugins": "/reporting-plugins/static-1.10122",
  "reporting-reports": "/reporting-reports/static-1.66642",
  "idb-keyval": "/idb-keyval/static-1.42",
  "reactive-lib": "/reactive-lib/static-1.615",
  "nest": "/nest/static-1.112",
  "codemirror": "/codemirror/static-5.93",
  "feedback-loader": "/feedback-loader/static-1.29082",
  "react-codemirror": "/react-codemirror/static-1.10514",
  "framework-listing-lib": "/framework-listing-lib/static-2.28326",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30398",
  "apps-service-types": "/apps-service-types/static-1.3768",
  "oauth-service-types": "/oauth-service-types/static-1.4138",
  "onboarding-scopes": "/onboarding-scopes/static-1.6353",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4613",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7576",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14712",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3519",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8872",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4391",
  "nav-client-types": "/nav-client-types/static-1.2249",
  "purchase-motions-api": "/purchase-motions-api/static-1.5664",
  "signup-constants": "/signup-constants/static-1.18635",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7930",
  "trials-service-types": "/trials-service-types/static-1.3792",
  "card-properties-lib": "/card-properties-lib/static-1.43817",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36756",
  "crm-actions": "/crm-actions/static-1.6205",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43224",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9034",
  "customer-data-tracking": "/customer-data-tracking/static-1.6773",
  "hs-resources": "/hs-resources/static-1.26",
  "pulse": "/pulse/static-1.425",
  "calling-global-api": "/calling-global-api/static-1.64060",
  "calling-internal-common": "/calling-internal-common/static-1.31192",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65442",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57736",
  "commerce-products-lib": "/commerce-products-lib/static-1.9117",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3707",
  "crm-links": "/crm-links/static-1.6166",
  "external-options-client-types": "/external-options-client-types/static-1.4068",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4133",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.521",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3599",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48349",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3875",
  "smart-property-lib": "/smart-property-lib/static-1.6383",
  "tiered-pricing": "/tiered-pricing/static-1.994",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10882",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4052",
  "react-dnd-compat": "/react-dnd-compat/static-1.4509",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5259",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2962",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1573",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.465",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7419",
  "academy-service-client": "/academy-service-client/static-1.3571",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28212",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8273",
  "video-components-external": "/video-components-external/static-1.10898",
  "video-data-lib": "/video-data-lib/static-1.34556",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "payment-link-components": "/payment-link-components/static-1.23204",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9778",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24120",
  "viral-links-lib": "/viral-links-lib/static-1.6929",
  "data-token-picker": "/data-token-picker/static-1.16211",
  "FileManagerLib": "/FileManagerLib/static-1.38893",
  "react-flip-move": "/react-flip-move/static-1.68",
  "timezone-utils": "/timezone-utils/static-2.5134",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17284",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8591",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7214",
  "customer-data-views-management": "/customer-data-views-management/static-1.25194",
  "framework-data-table": "/framework-data-table/static-2.11643",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6740",
  "nudge-client-utils": "/nudge-client-utils/static-1.2338",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.835",
  "app-users-service-client": "/app-users-service-client/static-1.5447",
  "app-users-service-types": "/app-users-service-types/static-1.4855",
  "mini-checkout-client": "/mini-checkout-client/static-1.26538",
  "onboarding-utils": "/onboarding-utils/static-1.5241",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1999",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28197",
  "edison-service-client-types": "/edison-service-client-types/static-1.278",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3073",
  "crm_data": "/crm_data/static-4.91581",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45685",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15501",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18759",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18224",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10071",
  "crm-fe-perf": "/crm-fe-perf/static-1.22793",
  "directed-graph": "/directed-graph/static-1.828",
  "event-emitter": "/event-emitter/static-1.838",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "calling-error-reporting": "/calling-error-reporting/static-1.31198",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10929",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6432",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.552",
  "commerce-permissions": "/commerce-permissions/static-1.656",
  "products-iframe-lib": "/products-iframe-lib/static-1.7606",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10089",
  "data-agent-kit": "/data-agent-kit/static-1.17",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9790",
  "policy-lib": "/policy-lib/static-1.6673",
  "react-tinymce": "/react-tinymce/static-1.54906",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9853",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54032",
  "tinymce-plugins": "/tinymce-plugins/static-1.57146",
  "tinymce-themes": "/tinymce-themes/static-1.56002",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1775",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1601",
  "user-context-client": "/user-context-client/static-1.4502",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6472",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11854",
  "content-media-compositions": "/content-media-compositions/static-2.15861",
  "media-bridge-lib": "/media-bridge-lib/static-1.18731",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5890",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4977",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3559",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21479",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3734",
  "audio-components": "/audio-components/static-1.5750",
  "FileManagerCore": "/FileManagerCore/static-1.38752",
  "FileManagerImages": "/FileManagerImages/static-1.36404",
  "video-components": "/video-components/static-1.12901",
  "crm-export-dialog": "/crm-export-dialog/static-1.6186",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6326",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1597",
  "tanstack-virtual": "/tanstack-virtual/static-1.28",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2095",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2414",
  "whisper-core-api": "/whisper-core-api/static-1.6261",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14490",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5269",
  "settings-content-modals": "/settings-content-modals/static-1.45743",
  "crm_universal": "/crm_universal/static-1.21813",
  "customer-data-email": "/customer-data-email/static-1.17841",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36807",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39179",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11550",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54332",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21132",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17401",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71545",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5461",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5225",
  "utility-belt": "/utility-belt/static-1.2430",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22294",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7310",
  "customer-data-rte": "/customer-data-rte/static-1.32697",
  "cv-backend-services": "/cv-backend-services/static-1.1536",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5512",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5002",
  "qrcode-generator": "/qrcode-generator/static-1.67",
  "quotes-client-types": "/quotes-client-types/static-1.37635",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35329",
  "sales-views-client-types": "/sales-views-client-types/static-1.4154",
  "hub-http-contrib": "/hub-http-contrib/static-1.2933",
  "interframe": "/interframe/static-3.4654",
  "tinymce-data": "/tinymce-data/static-1.40117",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5102",
  "layout-dnd-components": "/layout-dnd-components/static-1.12230",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11205",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14704",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8978",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4422",
  "video-embed": "/video-embed/static-1.35390",
  "social-insights-client-types": "/social-insights-client-types/static-1.21728",
  "deal-intel-utils": "/deal-intel-utils/static-1.1601",
  "checkout-sdk": "/checkout-sdk/static-3.23381",
  "checkout-service-types": "/checkout-service-types/static-1.3736",
  "company-details-components": "/company-details-components/static-1.6076",
  "payment-method-components": "/payment-method-components/static-1.6787",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13206",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3366",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3417",
  "access-control-lib": "/access-control-lib/static-1.10329",
  "EmailComponents": "/EmailComponents/static-1.54429",
  "EmailData": "/EmailData/static-1.53106",
  "redux-less": "/redux-less/static-2.9375",
  "sequences-lib": "/sequences-lib/static-1.7851",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10239",
  "products-ui-components": "/products-ui-components/static-1.39636",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80266",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6884",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54348",
  "commerce-products-api": "/commerce-products-api/static-1.2120",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56406",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102223",
  "stripe-connect-js": "/stripe-connect-js/static-1.66",
  "draft-content-plugins": "/draft-content-plugins/static-1.27965",
  "ContentData": "/ContentData/static-1.68057",
  "layout-data-lib": "/layout-data-lib/static-1.9530",
  "outpost": "/outpost/static-1.4085",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.782",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3820",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3880",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18366",
  "pricing-pages-api": "/pricing-pages-api/static-1.13071",
  "ContentComponents": "/ContentComponents/static-2.70938",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9466",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1834",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45905",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.767",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18527",
  "automation-ui-types": "/automation-ui-types/static-1.19445",
  "messaging-types-lib": "/messaging-types-lib/static-1.45642",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4394",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7708",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.410",
  "property-description-translator": "/property-description-translator/static-1.3744",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9067",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3547",
  "totals-ui-components": "/totals-ui-components/static-1.23251",
  "advanced-menus-core": "/advanced-menus-core/static-1.14956",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11920",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33721",
  "demographics-service-types": "/demographics-service-types/static-1.1541",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5361",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7230",
  "data-token-views": "/data-token-views/static-1.16192",
  "forms-utils-lib": "/forms-utils-lib/static-1.12369",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12809",
  "simple-menus-core": "/simple-menus-core/static-1.14955",
  "simple-menus-lib": "/simple-menus-lib/static-1.16472",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4144",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6662",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3410",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2548",
  "ContentEditorUI": "/ContentEditorUI/static-2.76793",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3877",
  "web-interactives-components": "/web-interactives-components/static-1.13571",
  "web-interactives-data": "/web-interactives-data/static-1.13572",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.216",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.386",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.867",
  "FireAlarmUi": "/FireAlarmUi/static-1.4419",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4076",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3726",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21381",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20844",
  "data-studio-ubb": "/data-studio-ubb/static-1.2389",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26691",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57426",
  "content-management-data-lib": "/content-management-data-lib/static-1.5246",
  "copilot-plugins": "/copilot-plugins/static-1.10781",
  "cta-picker": "/cta-picker/static-1.36098",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2727",
  "editor-components": "/editor-components/static-1.13071",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8250",
  "error-messaging-js": "/error-messaging-js/static-1.5081",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85538",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.63",
  "redux-request-state": "/redux-request-state/static-1.10536",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1643",
  "smart-content-core": "/smart-content-core/static-1.42125",
  "smart-content-lib": "/smart-content-lib/static-1.42778",
  "social-composer-lib": "/social-composer-lib/static-1.58515",
  "structured-content-lib": "/structured-content-lib/static-1.24881",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52935",
  "tinymce-copilot": "/tinymce-copilot/static-1.16100",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7742",
  "automation-ui-routing": "/automation-ui-routing/static-1.20802",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5551",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41900",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3049",
  "reporting-enablement": "/reporting-enablement/static-1.22449",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20759",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2223",
  "forms-ai-lib": "/forms-ai-lib/static-1.4146",
  "codemirror-dlb": "/codemirror-dlb/static-1.58352",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6319",
  "report-customization-components": "/report-customization-components/static-1.12800",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12568",
  "html-to-image": "/html-to-image/static-1.52",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1368"
}
};
